// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JevzyK9FC4XjiuBdmJV0{flex-direction:column;gap:40px;padding:37px 23px 0;display:flex}.hxY2sE7jGDUxjVHcknRE{flex-direction:column;display:flex}.RT13qYVApXQncNPtY9G1{padding-bottom:20px}.iavmYWSAYXkCNOpvyhEm{flex-direction:row;gap:12px;display:flex}.iavmYWSAYXkCNOpvyhEm+.iavmYWSAYXkCNOpvyhEm{margin-top:20px}.wncgvKP3stpVKWHlanQk{width:130px;min-width:130px;max-width:130px;color:var(--content-primary-tertiary);padding:4px 0}.Xegw5_N8V7EsnTo4JhkG{flex:1;min-width:0;padding:4px 0}.gv4HeFnWs4ra8BXWeAxI{color:var(--content-primary-disabled)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContent": `JevzyK9FC4XjiuBdmJV0`,
	"section": `hxY2sE7jGDUxjVHcknRE`,
	"head": `RT13qYVApXQncNPtY9G1`,
	"row": `iavmYWSAYXkCNOpvyhEm`,
	"name": `wncgvKP3stpVKWHlanQk`,
	"value": `Xegw5_N8V7EsnTo4JhkG`,
	"placeholder": `gv4HeFnWs4ra8BXWeAxI`
};
export default ___CSS_LOADER_EXPORT___;
